<div class="green-places-list">
    <h4 class="text-center py-2 text-white text-gray-600 mt-2" id="greenTitle">
      {{ 'PEST.PLOTS' | translate }}
    </h4>
    <div class="list-group">
      <a *ngFor="let plot of plots2" class="list-group-item list-group-item-action"
         [class.active]="selectedPlot === plot?.location"
         (click)="onSelectPlot(plot.plot_code, plot, plot.location)">
        <div class="d-flex justify-content-between align-items-start">
          <div class="w-100">
            <div class="d-flex align-items-center mb-1">
              <div class="icon-roundedGreen rounded-circle d-flex justify-content-center align-items-center">
                <mat-icon id="iconPlace">place</mat-icon>
              </div>
              <h5 class="mb-0 ml-2">{{ plot.location }}</h5>
            </div>
            <hr>
            <div class="d-flex flex-wrap justify-content-start info-blocks">
  
              <div class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-layer-group fa-lg icon-automatic"></i>
                  <span>{{ 'PEST.PLOT_CROPS' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.crop.length }}</span>
                  <small class="unit">{{ 'PEST.VALUE_PIECES' | translate }}</small>
                </div>
              </div>
  
              <div class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-microchip fa-lg icon-pesticides"></i>
                  <span>{{ 'PEST.PLOT_SENSORS' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.devices.length }}</span>
                  <small class="unit">{{ 'PEST.VALUE_PIECES' | translate }}</small>
                </div>
              </div>
  
              <div class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-map fa-lg icon-manual"></i>
                  <span>{{ 'PEST.PLOT_SIZE' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.size }}</span>
                  <small class="unit">{{ 'PEST.VALUE_ACRES' | translate }}</small>
                </div>
              </div>
  
              <div *ngIf="plot.total_diseases > 0" class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-bug fa-lg icon-yellow"></i>
                  <span>{{ 'PEST.PLOT_DISEASES' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.total_diseases }}</span>
                </div>
              </div>
  
              <div *ngIf="plot.total_pesticides > 0" class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-shield-virus fa-lg icon-water"></i>
                  <span>{{ 'PEST.PLOT_SPRAYING' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.total_pesticides }}</span>
                </div>
              </div>
  
              <div *ngIf="plot.total_fertilizers > 0" class="info-item-vertical">
                <div class="icon-label">
                  <i class="fa-solid fa-leaf fa-lg icon-available"></i>
                  <span>{{ 'PEST.PLOT_FERTILISER' | translate }}</span>
                </div>
                <div class="value-label-inline">
                  <span class="fw-bold">{{ plot.total_fertilizers }}</span>
                </div>
              </div>
  
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
  